module.exports = __webpack_public_path__ + "assets/spinner-6e04eddd0fd5fd443d81719f9375935f.svg";